import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {TextField, FormControl, Stack, Snackbar, Alert, LinearProgress, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
///import { LoadingButton } from '@mui/lab';
import AutocompleteTopics from '../components/AutocompleteTopics';
import axios from 'axios';
import Cookies from 'js-cookie';
import Tooltip from '@mui/material/Tooltip';
import QuestionBankUpload from './QuestionBankUpload';
import QuestionView from './QuestionView';
//import QuestionEdit from './QuestionEdit';
import DialogAuthorization from '../components/DialogAuthorization';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';
import Header from "../pages/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
//   var vertical='top',horizontal='center';
  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isadminloggedin');
	const childRefAuthorization = React.useRef();

	const [pageLoading, setPageLoading] = React.useState(false);

	var myCurrentDate=new Date();
	var myPastFromDate=new Date(myCurrentDate);
    myPastFromDate.setDate(myPastFromDate.getDate() - 366);

	

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);




	async function getUpdate(){
		///alert(userObj.token);
		
			setPageLoading(true);
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': userObj.loginId,
					'token': userObj.token,
					'device': 'web'					
				}
			}; 
			
			axios.get(env.API_URL+"/exams/read/topics-question-chart-allcounter", axiosHeader) 
			   .then(response => {
				// alert("status >> "+response.status); 
			 	// alert("Just Checking >> "+JSON.stringify(response)); 
				 setPageLoading(false); 
				if(response.data && response.data.responseTxt==="invalidToken"){ 
					Cookies.remove('isadminloggedin');
					window.location.href='login';
				}else if(response.data && response.data.responseTxt==="NoAuthorization"){ 
					childRefAuthorization.current.handleClickOpen();
				}else if(response.data && response.data.responseTxt==="success"){
					document.write(JSON.stringify(response.data));
				}else{
					document.write(JSON.stringify(response.data));
				}		
			})
			.catch((error) => {
				alert("ERROR: ", error);
			})	
			
	}

	return (
		<div> 
				<MetaTags>
            		<title>Update Question Counter</title>
          		</MetaTags>
				
				<Header title='Update Question Counter' />
				{pageLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
										<Button onClick={() => {getUpdate()}} style={{float:'left', marginTop: 3}} size="small" variant="contained" >{pageLoading?<>Updating...</>:<>Update</>}</Button>
									

								</Grid>
							</Grid>
					</Box>


				</Box>
				
			{/* <QuestionBankUpload topicId={topicId} topicName={topicName} ref={childRefUpload} updatedList={updatedList} />
			<QuestionView dataObj={dataObj} ref={childRefQW} /> */}

			{/* <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
			</Stack> */}


				<DialogAuthorization ref={childRefAuthorization} />

		</div>	
	);
  }